import React, { useContext, useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import { ConfigContext } from "../context/GlobalContext";
import { toast } from "react-toastify";
import { DeleteInvoice, EditProformaInvoice, EditQuotation } from "../data";
import { Languages } from "../Utils/Languages";
import * as actionType from "../context/actions";
const DeleteInvoiceView = ({ FirebaseId }) => {

    const { state, dispatch } = useContext(ConfigContext)

    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        const invoice = state.INVOICES?.find(
            inv => inv.uniqueID == FirebaseId
        );
        const matchedQuotation = state.QUOTATION?.find(
            q => q.invoiceId == invoice?.invoiceId
        );
    }, [FirebaseId])
    const handleDelete = async () => {

        try {

            // 🔎 Find invoice before deleting
            const invoice = state.INVOICES?.find(
                inv => inv.uniqueID === FirebaseId
            );

            if (!invoice) {
                toast.error("Invoice not found");
                return;
            }

            const selectedBusiness = state?.BUSINESSES?.find(b => b.companyId === invoice.companyId);
            const targetUid = selectedBusiness?.isShared ? selectedBusiness.ownerUid : state?.USERID;

            // ✅ Delete Invoice First
            const { success } = await DeleteInvoice(state, dispatch, FirebaseId, targetUid);

            if (!success) {
                toast.error(Languages[state?.LANGUAGE]?.inoive_delete_failed_message);
                return;
            }

            // =====================================
            // 🔥 UPDATE QUOTATION (MATCH BY invoiceId)
            // =====================================
            const matchedQuotation = state.QUOTATION?.find(
                q => q.invoiceId === invoice.invoiceId
            );

            if (matchedQuotation) {
                await EditQuotation(
                    state,
                    dispatch,
                    matchedQuotation.uniqueID,
                    {
                        ...matchedQuotation,
                        status: "",   // 👈 change based on your system
                    },
                    targetUid
                );
            }

            // =====================================
            // 🔥 UPDATE PROFORMA (MATCH BY invoiceId)
            // =====================================
            const matchedProforma = state.PROFORMAINVOICES?.find(
                p => p.invoiceId === invoice.invoiceId
            );

            if (matchedProforma) {
                await EditProformaInvoice(
                    state,
                    dispatch,
                    matchedProforma.uniqueID,
                    {
                        ...matchedProforma,
                        converted: false
                    },
                    targetUid
                );
            }

            toast.success(Languages[state?.LANGUAGE]?.invoice_delete_success_message);

        } catch (err) {
            console.error("Delete error:", err);
            toast.error("Something went wrong");
        }

        setShowModal(false);
    };


    return (
        <>
            {/* Delete Button */}
            <Link
                onClick={(e) => {
                    if (!state?.USERID) {
                        e.preventDefault();
                        dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                        return;
                    }
                    setShowModal(true);
                }}
                className="w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
            >
                <Icon icon="mingcute:delete-2-line" />
            </Link>

            {/* Delete Confirmation Modal */}
            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{Languages[state?.LANGUAGE]?.inoive_delete_conformation}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{Languages[state?.LANGUAGE]?.inoive_delete_conformation_text}</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        {Languages[state?.LANGUAGE]?.cancel}
                    </Button>
                    <Button variant="danger" className="bg-danger" onClick={handleDelete}>
                        {Languages[state?.LANGUAGE]?.delete}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default DeleteInvoiceView